module.exports = __webpack_public_path__ + "img/user-icon1.ba76560a.png";